// svd-pdp-before-after-2026.js – Skapad av Claude Code
(() => {
  'use strict';

  const SELECTOR_PAIR = '[data-svd-ba-pair]';
  const SELECTOR_VIEWPORT = '[data-svd-ba-viewport]';
  const SELECTOR_CLIP = '[data-svd-ba-clip]';
  const SELECTOR_HANDLE = '[data-svd-ba-handle]';
  const INIT_FLAG = 'svdBaInit';

  const clamp = (n, min, max) => Math.min(Math.max(n, min), max);

  const initPair = (pair) => {
    if (!pair || pair.dataset[INIT_FLAG] === '1') return;

    const viewport = pair.querySelector(SELECTOR_VIEWPORT);
    const clip = pair.querySelector(SELECTOR_CLIP);
    const handle = pair.querySelector(SELECTOR_HANDLE);
    if (!viewport || !clip || !handle) return;

    pair.dataset[INIT_FLAG] = '1';

    const initialRaw = parseFloat(pair.getAttribute('data-initial'));
    let current = Number.isFinite(initialRaw) ? initialRaw : 50;

    const setPosition = (pct) => {
      const clamped = clamp(pct, 0, 100);
      const rounded = Math.round(clamped * 10) / 10;
      current = rounded;
      clip.style.width = rounded + '%';
      handle.style.left = rounded + '%';
      handle.setAttribute('aria-valuenow', String(Math.round(rounded)));
    };

    setPosition(current);

    const pctFromClientX = (clientX) => {
      const rect = viewport.getBoundingClientRect();
      if (rect.width <= 0) return null;
      return ((clientX - rect.left) / rect.width) * 100;
    };

    let activePointerId = null;
    let captureTarget = null;

    const onPointerMove = (e) => {
      if (activePointerId === null || e.pointerId !== activePointerId) return;
      const pct = pctFromClientX(e.clientX);
      if (pct === null) return;
      setPosition(pct);
    };

    const endDrag = (e) => {
      if (activePointerId === null) return;
      if (e && e.pointerId !== activePointerId) return;
      try {
        if (captureTarget && captureTarget.releasePointerCapture) {
          captureTarget.releasePointerCapture(activePointerId);
        }
      } catch (_) { /* noop */ }
      activePointerId = null;
      captureTarget = null;
      pair.classList.remove('is-dragging');
      window.removeEventListener('pointermove', onPointerMove);
      window.removeEventListener('pointerup', endDrag);
      window.removeEventListener('pointercancel', endDrag);
    };

    const onPointerDown = (e) => {
      if (e.button !== undefined && e.button !== 0) return;
      const rect = viewport.getBoundingClientRect();
      if (rect.width <= 0) return;

      e.preventDefault();

      activePointerId = e.pointerId;
      captureTarget = (e.target === handle || handle.contains(e.target)) ? handle : viewport;
      try {
        captureTarget.setPointerCapture(e.pointerId);
      } catch (_) { /* noop */ }

      pair.classList.add('is-dragging');

      const pct = pctFromClientX(e.clientX);
      if (pct !== null) setPosition(pct);

      window.addEventListener('pointermove', onPointerMove);
      window.addEventListener('pointerup', endDrag);
      window.addEventListener('pointercancel', endDrag);
    };

    viewport.addEventListener('pointerdown', onPointerDown);

    handle.addEventListener('keydown', (e) => {
      const step = e.shiftKey ? 10 : 1;
      let handled = true;
      switch (e.key) {
        case 'ArrowLeft':
        case 'ArrowDown':
          setPosition(current - step);
          break;
        case 'ArrowRight':
        case 'ArrowUp':
          setPosition(current + step);
          break;
        case 'Home':
          setPosition(0);
          break;
        case 'End':
          setPosition(100);
          break;
        case 'PageUp':
          setPosition(current + 10);
          break;
        case 'PageDown':
          setPosition(current - 10);
          break;
        default:
          handled = false;
      }
      if (handled) e.preventDefault();
    });
  };

  const initWithin = (root) => {
    const scope = root || document;
    const pairs = scope.querySelectorAll
      ? scope.querySelectorAll(SELECTOR_PAIR)
      : [];
    pairs.forEach(initPair);
    // Om root själv är ett pair
    if (root && root.matches && root.matches(SELECTOR_PAIR)) {
      initPair(root);
    }
  };

  const boot = () => initWithin(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (e) => {
    initWithin(e.target || document);
  });
})();
